﻿myApp.directive('itemup', function () {
    return {
        link: function (scope, elm) {
            if (scope.$last) {
                setTimeout(function () {
                    scope.rowUp()
                }.bind(this), 1500);
            }
        }
    }
});
require("./moreprojects");
myApp.controller("projectCtrl", ['$scope', '$http', function ($scope, $http) {
    if ($("body").hasClass("heb")) {
        $("*").css("font-family", '"Open Sans Hebrew", sans-serif');
    }
    $("header").addClass("fixed-top");
    $("header").removeClass("inverse-c");

    $scope.setProjectPage();
    function fixHeader() {
        if (innerWidth <= 992) {
            $("header").removeClass("fixed-top");
            $("header").addClass("inverse-c");
        }
        else {
            $("header").addClass("fixed-top");
            $("header").removeClass("inverse-c");
        }
    }


    fixHeader();
    $(window).on("resize", fixHeader);
    $scope.setPageClass("yit-projects ngproject");
    $scope.setPage("projects");//navbar action

 
    $scope.background = "";
    var prm = getParameterByName("project");
    if (prm) {
        $scope.className = prm.trim();
    }
    else {
        $scope.className = $scope.projectType;
    }



    $scope.Header = "";
    $scope.subHeader = "";
    $scope.description = "";
    $scope.tags = [];
    $scope.projects_slide = [];
    $scope.items = [];
    $scope.closing = "";
    $scope.extra = "";
    $scope.btns = [];

    $scope.getAll = function () {
        $http.get("../../data/projects.xml")
            .then(function (data) {
                var xml = $.parseXML(data.data)
                var current = $(xml).find("Projects > " + $scope.className + "");
                if (current.length > 0) {
                    $scope.parseProjects($(xml).find("Projects").find($scope.className));
                    $scope.moreProjects($(xml).find("slides").find("slide"));
                }
                else {

                    $scope.setPageClass("yit-404");
                    $scope.Header = "404";
                    $scope.subHeader = "לא קיים פרוייקט כזה";
                    $(".col.unfixed *").css("color", "black");
                    var cover = "../../images/oh-snap_03.png";
                    $(".col.unfixed").css("background-image", "url('" + cover + "')");
                }

            });
    }
    $scope.getAll();
    $scope.parseProjects = function (projects) {
        var className = $(projects).find("class").text().trim();
        var cover = $(projects).find("cover").text().trim();
        $scope.cover = cover+"_"+$scope.lang+".jpg";
        $("body").addClass(className);
     
        $(".col.unfixed").css("background-image", "url('" + $scope.cover + "')");
        try {
            setCover();
        } catch (e) {

        }

        $scope.Header = $(projects).find("header").find($scope.lang).text().trim();
         
        $scope.subHeader = $(projects).find("subheader").find($scope.lang).text();
        $scope.description = $(projects).find("description").find($scope.lang).text().trim();
        $scope.closing = $(projects).find("closing").find($scope.lang).text().trim();
        $scope.extra = $(projects).find("extra").find($scope.lang).text().trim();

        //$("title").html("Yit - " + $scope.Header);//page title
        $scope.setTitle($scope.Header);//sub header
     
        $("h2").html($scope.subHeader);//sub header
         //call generate tags 
        $scope.generateTags($(projects).find("tags tag"));
        $scope.generateItems($(projects).find("items item"));//create images
        $(".yedioth").find(".fixed-top").addClass("inverse");//change navbar 
        $scope.generateBtns($(projects).find("btns"));//creates buttons


        var dir = $(projects).find("dir").text().trim();
        setTimeout(function () {
            reverseList(dir);
        }, 100);

    }

    $scope.generateTags = function (tags) {
        $(tags).each(function () {
            var tagname = $(this).text().trim();
            var tagClass = "";
            switch (tagname) {
                case "Mobile":
                    tagClass = "a";
                    break;
                case "CMS":
                    tagClass = "b";
                    break;
                case "Hosting":
                    tagClass = "c";
                    break;
                case "UI/UX":
                    tagClass = "d";
                    break;
                case "Anlaysis":
                    tagClass = "e";
                    break;
                case "Development":
                    tagClass = "f";
                    break;
            }
            $scope.tags.push({
                css: tagClass,
                text: tagname
            });
        });
    }
    $scope.generateItems = function (items) {
        $(items).each(function () {
            var img = $(this).find("img").text().trim();
            var title = $(this).find("title").find($scope.lang).text();
            var p = $(this).find("p").find($scope.lang).text();
            var type = $(this).find("type").text().trim();
            $scope.items.push({
                type: type,
                img: img,
                title: title,
                p: p
            });

        });
    }
    $scope.generateBtns = function (btns) {
        var web = $(btns).find("web").text().trim();

        if (web) {
            var text = "Visit site";
            if ($scope.lang == "heb") {
                text = "לאתר";
            }

            $scope.btns.push({

                link: web,
                text: text
            });

        }
        else if ($(btns).find("app")) {
            var apps = $(btns).find("app");
            var ios = apps.find("ios").text().trim();
            var android = apps.find("android").text().trim();
            if (ios) {
                var text = "App Store";
                $scope.btns.push({
                    link: ios,
                    text: text
                });
            }
            if (android) {
                var text = "Google Play";
                $scope.btns.push({
                    link: android,
                    text: text
                });
            }
        }
    }
    $scope.moreProjects = function (slides) {
        $(slides).each(function (index) {
            $scope.projects_slide.push({
                name: $(this).find("name").find($scope.lang).text().trim(),
                img: $(this).find("img").text().trim(),
                ref: $(this).find("ref").text().trim()
            });
        });
    }
    $scope.rowUp = function () {
        var items = "";
        for (var i = 0; i < this.items.length; i++) {
            items += ".item-" + i;
            if (i < this.items.length - 1) {
                items += ",";
            }

        }
    }
}]);

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function reverseList(dir) {
    if (dir == "l") {
        $(".regular,.big").each(function (index) {
            if (index % 2 == 0) {
                $(this).find(".itemflex").addClass("item-rev");
            }
        });
    }
    else {
        $(".regular,.big").each(function (index) {
            if (index % 2 != 0) {
                $(this).find(".itemflex").addClass("item-rev");
            }
        });
    }

}


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/projects.js
// module id = 16
// module chunks = 0